import {FetchAction, FetchState} from "App/services";
import {ActionType, ApiErrorType} from "App/constants";

export interface ResetPasswordState {
    error: ApiErrorType
    submitting: boolean
    reset: boolean
}

export function resetPasswordReducer(state: ResetPasswordState | null = null, action: FetchAction) {
    switch (action.type) {
        case ActionType.START_RESETPASSWORD: {
            return {
                error: ApiErrorType.NONE,
                submitting: false,
                reset: false
            }
        }
        case ActionType.RESETPASSWORD: {
            switch (action.state) {
                case FetchState.FETCHING: {
                    return {
                        ...state,
                        error: ApiErrorType.NONE,
                        submitting: true,
                        reset: false
                    }
                }
                case FetchState.SUCCESS: {
                    return {
                        ...state,
                        error: ApiErrorType.NONE,
                        submitting: false,
                        reset: true
                    }
                }
                case FetchState.FAILURE: {
                    return {
                        error: action.payload.name,
                        submitting: false,
                        reset: false,
                    }
                }
                default:
                    return state;
            }
        }
        case ActionType.CANCEL_RESETPASSWORD:
            return null;
        default:
            return state
    }
}

export function startResetPassword(): any {
    return {
        type: ActionType.START_RESETPASSWORD,
    }
}

export function cancelResetPassword(): any {
    return {
        type: ActionType.CANCEL_RESETPASSWORD,
    }
}


// WEBPACK FOOTER //
// ./src/services/reducers/resetpassword.ts